import * as React from "react";
import type { SVGProps } from "react";
const SvgSweater = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      d="M12 5a3 3 0 0 0 2.52-1.37c.23-.35.6-.63 1.02-.63H17a5 5 0 0 1 5 5v9a1 1 0 0 1-1 1h-3v2a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1v-2H3a1 1 0 0 1-1-1V8a5 5 0 0 1 5-5h1.46c.43 0 .8.28 1.02.63A3 3 0 0 0 12 5ZM8 5H7a3 3 0 0 0-3 3v8h2V9a1 1 0 0 1 1-1 1 1 0 0 1 1 1v10h8V9a1 1 0 0 1 1-1 1 1 0 0 1 1 1v7h2V8a3 3 0 0 0-3-3h-1a5 5 0 0 1-8 0Z"
    />
  </svg>
);
export default SvgSweater;
